import { render, staticRenderFns } from "./CreatePublisher.vue?vue&type=template&id=9ae14f92&"
import script from "./CreatePublisher.vue?vue&type=script&lang=js&"
export * from "./CreatePublisher.vue?vue&type=script&lang=js&"
import style0 from "./CreatePublisher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports